module.exports = __webpack_public_path__ + "img/DefaultCommunityVisual.697e7819.png";